export default __webpack_public_path__ + "static/media/logout2.67ed5f54.svg";